import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { Empty } from "@/components/common";
import { api, fmtDate } from "@/lib/api";

export function PopularView({ onOpen }) {
  const [year, setYear] = useState(0);
  const [data, setData] = useState(null);
  useEffect(() => {
    let stale = false;
    api.get("/practicals-popular", { params: { year_group: year } }).then((r) => { if (!stale) setData(r.data); });
    return () => { stale = true; };
  }, [year]);
  if (!data) return <p className="text-sm text-muted-foreground">Loading…</p>;
  const max = Math.max(1, ...data.items.map((i) => i.times_booked));
  return (
    <div className="space-y-4" data-testid="popular-view">
      <div className="flex flex-wrap gap-2" data-testid="popular-year-chips">
        {[0, ...data.years].map((y) => (
          <button key={y} onClick={() => setYear(y)} data-testid={`popular-year-${y || "all"}`}
            className={`rounded-full border px-3 py-1 text-sm transition-colors ${year === y ? "bg-primary text-primary-foreground border-primary" : "bg-card hover:border-primary/50"}`}>
            {y ? `Year ${y}` : "All years"}
          </button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Ranked by how often the department has booked each practical (cancelled bookings excluded).</p>
      {data.items.length === 0 ? <Empty>No bookings yet for this year group.</Empty> : (
        <ol className="rounded-xl border bg-card divide-y" data-testid="popular-list">
          {data.items.map((it, i) => (
            <li key={`${it.practical_id}-${it.year_group}`}>
              <button onClick={() => onOpen(it.practical_id)} className="w-full text-left flex items-center gap-4 px-4 py-3 hover:bg-muted/40" data-testid={`popular-item-${it.practical_id}-${it.year_group}`}>
                <span className="font-display text-lg font-bold w-6 text-muted-foreground">{i + 1}</span>
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{it.name}</div>
                  <div className="text-xs text-muted-foreground flex flex-wrap gap-x-3">
                    <span>{it.subject || "No subject"}{it.year_group ? ` · Year ${it.year_group}` : ""}</span>
                    <span className="inline-flex items-center gap-1"><Users className="h-3 w-3" />{it.teachers.join(", ")}</span>
                    <span>Last run {fmtDate(it.last_date)}</span>
                  </div>
                  <div className="h-1.5 rounded-full bg-muted mt-2 overflow-hidden"><div className="h-full bg-primary" style={{ width: `${(it.times_booked / max) * 100}%` }} /></div>
                </div>
                <span className="text-sm font-semibold whitespace-nowrap" data-testid={`popular-count-${it.practical_id}-${it.year_group}`}>{it.times_booked}×</span>
              </button>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
